import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-business-lending-cmb.component.scss';
var FormItemBusinessLendingCmb = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemBusinessLendingCmb, _super);
    function FormItemBusinessLendingCmb(element) {
        return _super.call(this, element) || this;
    }
    FormItemBusinessLendingCmb.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = Array.from(this.element.querySelectorAll(".js-apply-now__button"));
        this.enquiryType = this.element.querySelector("select[name=enquiry-type]");
        this.recipientInput = this.element.querySelector("input[name=recipient]");
        this.emailInput = this.element.querySelector("input[name=email]");
        this.subjectInput = this.element.querySelector("input[name=subject]");
        this.currentBank = this.element.querySelector("select[name=current-bank]");
        this.selectProvince = this.element.querySelector(".js-vaf__province");
        this.hiddenEmail = this.element.querySelector("input[name=email]");
        this.hiddenRecipient = this.element.querySelector("input[name=recipient]");
    };
    FormItemBusinessLendingCmb.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
            // Reset the form
            this.form.addEventListener("custom_form_reset_event", function (pEvent) {
                _this.resetForm();
            }, false);
        }
        if (this.currentBank) {
            this.currentBank.addEventListener("change", function (pEvent) {
                var _currentBank = pEvent.target.value;
                var _redirectedFrom = _this.getRedirectPage();
                if (_currentBank !== "STANDARD_BANK") {
                    var thankYou = _this.element.querySelector(".form__thankyou--container");
                    var declined = _this.element.querySelector(".form__declined--container");
                    var fieldsContainer = _this.element.querySelector(".form__fields--container");
                    var tellMeMoreBtn = _this.element.querySelector(".business-lending__tell-me-more--button");
                    if (thankYou && declined && fieldsContainer && tellMeMoreBtn) {
                        thankYou.classList.remove("active");
                        thankYou.classList.add("hidden");
                        fieldsContainer.classList.add("hidden");
                        declined.classList.add("active");
                        declined.classList.remove("hidden");
                        tellMeMoreBtn.setAttribute("href", "/southafrica/business/products-and-services/borrow-for-your-needs/cash-flow-solutions/business-term-loan?cusIsRedirected=YES&productRedirectedFrom=" + _redirectedFrom + "&cusBank=" + _currentBank);
                    }
                }
            });
        }
        if (this.enquiryType) {
            this.enquiryType.addEventListener("change", function (event) { return _this.queryType(event); });
        }
    };
    FormItemBusinessLendingCmb.prototype.getRedirectPage = function () {
        if (window.location.href.includes("business-overdraft")) {
            return 'BUSINESS_OVERDRAFT';
        }
        else if (window.location.href.includes("revolving-credit-plan")) {
            return 'BRCP';
        }
        else if (window.location.href.includes("agricultural-production-loan")) {
            return 'BUSINESS_AGRI_LOAN';
        }
        else if (window.location.href.includes("fixed-repayments-business-loan")) {
            return 'BUS_FIXED_REPAYMENTS';
        }
        else {
            return '';
        }
    };
    FormItemBusinessLendingCmb.prototype.queryType = function (event) {
        var value = event.target.value;
        this.recipientInput.value = value;
        this.emailInput.value = value;
        var _form = this.enquiryType.closest("form");
        var _phoneNumber = _form.querySelector("input[name=phone-number]");
        var _phoneParent = _phoneNumber.parentElement;
        if (value === "enterprisedirect2@standardbank.co.za") {
            var _businessReg = _form.querySelector("input[name=business-registration]");
            if (!_businessReg) {
                var _newElement = document.createElement("div");
                _newElement.classList.add("form__group");
                var _newLabel = document.createElement("label");
                _newLabel.classList.add("form__label");
                _newLabel.appendChild(document.createTextNode("Business Registration"));
                var _newInput = document.createElement("input");
                _newInput.classList.add("form__input", "form__input--required");
                _newInput.setAttribute("name", "business-registration");
                _newInput.setAttribute("value", "");
                _newInput.setAttribute("type", "text");
                _newInput.setAttribute("placeholder", "Enter your business registration number");
                _newElement.appendChild(_newLabel);
                _newElement.appendChild(_newInput);
                _phoneParent.parentNode.insertBefore(_newElement, _phoneParent.previousSibling);
            }
        }
        else {
            var _businessReg = _form.querySelector("input[name=business-registration]");
            if (_businessReg) {
                var _temp = _businessReg.parentNode;
                _temp.parentNode.removeChild(_temp);
            }
        }
    };
    FormItemBusinessLendingCmb.prototype.resetForm = function () {
        if (this.form) {
            this.form.reset();
            var formContainerLoader = this.element.querySelector(".form__loader--container");
            var formContainerFields = this.element.querySelector(".form__fields--container");
            var formContainerThankyou = this.element.querySelector(".form__thankyou--container");
            var formDeclined = this.element.querySelector(".form__declined--container");
            formContainerLoader.classList.remove("active");
            formDeclined.classList.remove("active");
            formDeclined.classList.add("hidden");
            formContainerThankyou.classList.remove("active");
            formContainerThankyou.classList.add("hidden");
            formContainerFields.classList.remove("hidden");
        }
    };
    FormItemBusinessLendingCmb.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var declined = form.querySelector(".form__declined--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // fields
        var fields = $(form).serialize();
        fields += '&formLocation=' + this.formLocationService.getLocation();
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var url = this.baseUrl + "/services/SubmitGenericForm.jsp";
        // service
        this.formsService.postForm(url, fields).then(function (pResponse) {
            // service ok
            loader.classList.remove("active");
            _this.analyticsService.dtmFormComplete("complete", "");
            declined.classList.remove("active");
            declined.classList.add("hidden");
            thankYou.classList.remove("hidden");
            thankYou.classList.add("active");
        }).catch(function (pResponse) {
            // service failed
            loader.classList.remove("active");
            this.analyticsService.dtmFormComplete("complete", "");
            declined.classList.remove("active");
            declined.classList.add("hidden");
            thankYou.classList.remove("hidden");
            thankYou.classList.add("active");
        });
    };
    return FormItemBusinessLendingCmb;
}(Base));
export { FormItemBusinessLendingCmb };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-business-lending-cmb/form-item-business-lending-cmb.component.ts
// module id = 869
// module chunks = 0